import React, { useState } from 'react';
import CostCentreLayer from './CostCentreLayer';
import CurrencyLayer from './CurrencyLayer';
import ExpenseCodeListLayer from './ExpenseCodeListLayer';
import CostResponsibilityLayer from './CostResponsibilityLayer';

const tabs = [
  { key: 'cost-centre', label: 'Cost Centre', Component: CostCentreLayer },
  { key: 'currency', label: 'Currencies', Component: CurrencyLayer },
  { key: 'expense-code', label: 'Expense Codes', Component: ExpenseCodeListLayer },
  { key: 'cost-responsibility', label: 'Cost Responsibility', Component: CostResponsibilityLayer },
];

const FinanceReferencesLayer = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const ActiveComponent = tabs.find(t => t.key === activeTab).Component;
  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map(t => (
            <li key={t.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default FinanceReferencesLayer;
